module.exports = __webpack_public_path__ + "img/alentour15.3725a3c6.jpg";